import { convertUserFromServer } from "../../utils/user";
import { SET_USER_PAGE_USER_DATA, SET_USER_PAGE_USER_LOADING, } from "../constants";
const reducer = (state, action) => {
    switch (action.type) {
        case SET_USER_PAGE_USER_DATA: {
            const { user, customFields } = action.payload;
            return Object.assign(Object.assign({}, state), { user: convertUserFromServer(user), customFields });
        }
        case SET_USER_PAGE_USER_LOADING: {
            const loading = action.payload;
            return Object.assign(Object.assign({}, state), { loading });
        }
        default:
            return state;
    }
};
export { reducer };
